import { Grid,Container,Group, createStyles, Paper, Text, Title, Alert, Badge, Button, Loader} from '@mantine/core';

import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useEffect, useState } from 'react';

import { ShowUserForMeeting } from './helper/ShowUserForMeeting';
import intl from 'react-intl-universal';


dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);

/*interface GuestMeetingData {
    id: any;
    drnId: null,
    status:  any;
    title: string;
    datEnd: string;  
    datStart: string; 
}*/

const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  contback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  sysback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "70vw",
    position: "relative",
  },

  guestfooter: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
    backgroundColor: "#efefef",
    borderTop: `1px solid #ddd`,
    paddingLeft: `20px`,
    paddingRight: `20px`,
  },
  footerheadline: {
    fontWeight: 200,
    fontSize: "1.2em",
    color: "#00445E"
  },
  inside: {
    listStyleType: "none",
    paddingLeft: 0,
    margin: "0 0 20px;"
  },
  inside_li: {
    fontWeight: 400,
    fontSize: "89%",
    color: "#00445E",
  },
  paper: { 
    width: "60vw",
  },
  padtop10: {
    paddingTop: `10px`,
  },
}));


const GuestLobby = (props:any) => {
    const dispatch = useDispatch()
    const { classes } = useStyles();
    const guestmeetingdata = useSelector((state: any) => state.user.guest_meetinginfo)
    const guest_isValid = useSelector((state: any) => state.user.guest_isValid)
    const guestme = useSelector((state: any) => state.user.guest_meinfo)
    const guest_joinlink = useSelector((state: any) => state.user.guest_joinlink)
    const guestmeetingparticipantsdata = useSelector((state: any) => state.user.guest_meeting_participants)

    const [conditionMet, setConditionMet] = useState(false);
    const [remainingTime, setRemainingTime] = useState<string>('');

    const [lobbyopen, setLobbyopen] = useState(false);

    const [beforeendtimer, setBeforeend] = useState(false);


    // Test Only
  /* const guestmeetingdata: GuestMeetingData = {
      id: '982774ad-226a-431a-8247-08dce1f0b30f',
      drnId: null,
      status: 'Finished',
      title: 'FixTEst',
      datEnd: '2024-10-15T14:50:00+02:00',  
      datStart: '2024-10-15T14:32:00+02:00'
    }; */

      //let teststart = '2024-10-15T15:43:00+02:00'
      //let testend = '2024-10-15T15:30:00+02:00'

     // console.log(beforeendtimer)
     // console.log(lobbyopen)
    
    useEffect(() => {
      // Request the initial meeting data
      const reqmeetingdatapayload = {
        MeetingParticipantId: guestme.id,
      };
      //console.log("GUEST_SIGNALR_GETMEETINGDATA")
      if (guestmeetingdata.id === undefined) {
        dispatch({ type: 'GUEST_SIGNALR_GETMEETINGDATA', payload: reqmeetingdatapayload });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      // Triggers Display of Lobby open but Notar is not ready yet
      if (guest_joinlink.meetingId !== undefined && guest_joinlink.joinLink === null) {
        setLobbyopen(true);
      }
    }, [guest_joinlink]);


    useEffect(() => {
      const now = dayjs();
      let datStart: any;
      let datStartPlusOneHour: any;
      let intervalbefore: NodeJS.Timeout | null = null;

      if (guestmeetingdata.datStart !== undefined) {

        datStart = dayjs(guestmeetingdata.datStart);
        //datStart = dayjs(teststart);
        datStartPlusOneHour = dayjs(datStart).subtract(10, 'minute');

      if (now.isBefore(datStartPlusOneHour)) { 
        //setLobbyopen(true);
        //console.log("isBefore");
        //console.log("datStart" + datStart.format('HH:mm'));
        //console.log("datStartPlusOneHour" + datStartPlusOneHour.format('HH:mm'));
        //const diff = datStart.diff(now);
        //console.log(diff)
        //console.log(now.format('HH:mm'));

        intervalbefore = setInterval(() => {
          const now = dayjs(); // Get the current time inside the interval
          const diff = datStartPlusOneHour.diff(now);
          
          if (diff <= 0) {
            //console.log("Lobby opend after Toimer is down");
            setBeforeend(true);
            setLobbyopen(true);
            if (intervalbefore !== null) {
              clearInterval(intervalbefore); // Stop the interval once the condition is met
              intervalbefore = null; // Set interval to null to prevent errors
            }
          } else {
            setRemainingTime(formatRemainingTimebefore(diff));
          }
        }, 1000); 
      }
      }
      return () => {
        if (intervalbefore) {
          clearInterval(intervalbefore);
        }
      };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestmeetingdata,guest_joinlink,guestmeetingparticipantsdata]);

    useEffect(() => {
      const now = dayjs();
      let datStart: any;
      let datStartPlusOneHour: any;
      let interval: NodeJS.Timeout | null = null; 
      

      //console.log(guestmeetingdata.datStart);
     // console.log("HAllo");
  
      if (guestmeetingdata.datStart !== undefined) {
        
        datStart = dayjs(guestmeetingdata.datStart);
        //datStart = dayjs(teststart);
        datStartPlusOneHour = dayjs(datStart).subtract(10, 'minute');
    
/*
        if (now.isBetween(datStartPlusOneHour,datStart)) { 
          console.log("iisBetween");
        } else {
          console.log(datStart.format('HH:mm'));
          console.log(now.format('HH:mm'));
          console.log(datStartPlusOneHour.format('HH:mm'));
        }

       if (now.isAfter(datStart)) { 
        console.log("isAfter");
        console.log(datStart.format('HH:mm'));
        console.log(datStartPlusOneHour.format('HH:mm'));
        const diff = datStart.diff(now);
        console.log(diff)
        console.log(now.format('HH:mm'));
       }
*/
       
 
    
        // Check if the meeting has started
      if (datStart.isBefore(now)) { 
         // console.log("isBefore -> Meeting have startet");
         // console.log(datStart.format('HH:mm'));
         // console.log(now.format('HH:mm'));
          setLobbyopen(true);
          setConditionMet(true);
      } else if (now.isBetween(datStartPlusOneHour,datStart)) {
          console.log("isBetween -> Timer have startet");
          setLobbyopen(true);
          // Meeting has not started yet, but it's within 1 hour, so start the timer
          interval = setInterval(() => {
            const now = dayjs(); // Get the current time inside the interval
            const diff = datStart.diff(now);
            //console.log(diff);
            if (diff <= 0) {
              //console.log("Lobby opend after Toimer is down");
              setConditionMet(true);
              if (interval !== null) {
                clearInterval(interval); // Stop the interval once the condition is met
                interval = null; // Set interval to null to prevent errors
              }
            } else {
              setRemainingTime(formatRemainingTime(diff));
            }
          }, 1000); 
        }
      }
    
      // Cleanup interval on component unmount
      return () => {
        if (interval) {
          clearInterval(interval);
        }
      };
    }, [guestmeetingdata,guest_joinlink,guestmeetingparticipantsdata,beforeendtimer]); 

    const formatRemainingTime = (milliseconds: number) => {
        const duration = dayjs.duration(milliseconds);
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        const daysDisplay = days > 0 ? `${days} Tage ` : '';
        return `${daysDisplay} ${hours}h ${minutes}m ${seconds}s`;
    };

    const formatRemainingTimebefore = (milliseconds: number) => {
      const duration = dayjs.duration(milliseconds);
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      const daysDisplay = days > 0 ? `${days} Tage ` : '';
      return `${daysDisplay} ${hours}h ${minutes}m ${seconds}s`;
  };
  
    //console.log(dayjs(guestmeetingdata.datStart).subtract(2, 'hour'))
    //console.log(dayjs(guestmeetingdata.datStart).format('HH:mm'))
    //console.log(conditionMet)
  return (
    <>
    <Container fluid className={classes.contback}> 
          <Paper shadow="sm" p="xl" className={classes.paper}>
          <Title order={2} align={"center"}>{guestmeetingdata.title}</Title>
          <hr />
          <Grid>
            <Grid.Col span={4}>{intl.get('GUESTLOBBY_DATUM')}: </Grid.Col>
            <Grid.Col span={8}><strong>{dayjs(guestmeetingdata.datStart).format('DD.MM.YYYY')}</strong> {intl.get('GUESTLOBBY_VON')}  <strong>{dayjs(guestmeetingdata.datStart).format('HH:mm')}</strong> {intl.get('GUESTLOBBY_BIS')} <strong>{dayjs(guestmeetingdata.datEnd).format('HH:mm')}</strong> {intl.get('GUESTLOBBY_UHR')} </Grid.Col>
          </Grid> 
          {!conditionMet &&
          <Grid>
          <Grid.Col span={4}>
          {!beforeendtimer &&
            <>{intl.get('GUESTLOBBY_TERMSTARTLOBBY')}:</>
          }
          {beforeendtimer &&
           <> {intl.get('GUESTLOBBY_TERMSTART')}: </>
          }

          
            
            </Grid.Col>
          <Grid.Col span={8}>
                <strong>{remainingTime}</strong>
           </Grid.Col>
          </Grid>
          } 
          
          <Grid>
            <Grid.Col span={4}>{intl.get('GUESTLOBBY_STATUS')}:</Grid.Col>
            <Grid.Col span={4}>
                {guest_isValid &&
                <strong><Badge color="green">{intl.get('GUESTLOBBY_STATUS_OK')}</Badge></strong>
                } 
                {!guest_isValid &&
                <strong><Badge color="red">{intl.get('GUESTLOBBY_STATUS_NOTOK')}</Badge></strong>
                }
            </Grid.Col>
            <Grid.Col span={4}>
                {!lobbyopen &&
                <strong><Badge color="red">{intl.get('GUESTLOBBY_WR_CLOSED')}</Badge></strong> 
                }
                {lobbyopen &&
                <strong><Badge color="green"><Group>{intl.get('GUESTLOBBY_WR')}   <Loader color="gray" variant="dots" /></Group></Badge></strong> 
                }
              
              </Grid.Col>
          </Grid> 
          <hr />
               {!lobbyopen &&
               <>
                  <Alert  title="Information" >
                  {intl.get('GUESTLOBBY_WR_INFO_10')}
                 </Alert>
                <hr />
                <Text>{intl.get('GUESTLOBBY_WR_INFO_1')} </Text>
                <Text mb={20}>{intl.get('GUESTLOBBY_WR_INFO_2')}  </Text>
                <Group position="center">
                {/*<Button onClick={() => props.requestjoinlink()}  variant="outline">Test ONLY für Request Joinlink</Button>*/}
                </Group>
                </>
                }

                {lobbyopen &&
               <>
               
                <strong>{intl.get('GUESTLOBBY_PARTICIPANTS')}:</strong> <br />
                
                  <ShowUserForMeeting />
                  <hr />
                  <Alert  title="Information" color="green">
                  {intl.get('GUESTLOBBY_BEFORJOIN_INFO_1')} <strong>{guestmeetingdata.title}</strong>!<br />
                  {intl.get('GUESTLOBBY_BEFORJOIN_INFO_2')}<br />
                  {intl.get('GUESTLOBBY_BEFORJOIN_INFO_3')} 
                 </Alert>
                 <hr />
                <Text>{intl.get('GUESTLOBBY_BEFORJOIN_INFO_4')}  </Text>
                
                
                </>
                }



      </Paper>
      </ Container>    
    </> 
    );
  }
  
  export default GuestLobby;